import angular from 'angular';
import _ from 'lodash';
import moment from 'moment';

export const range = () => function (input, total) {
    total = parseInt(total);

    for (let i = 1; i <= total; i++) {
        input.push(i);
    }

    return input;
};

export const getDisplayCandidateTitles = () => function (input) {
    if (!input) {
        return;
    }
    let ans = '';
    for (let i = 0; i < input.length; i++) {
        if (i === 0) {
            ans = input[i].title;
        } else {
            ans = `${ans} & ${input[i].title}`;
        }
    }
    return ans;
};

export const getJobSeekerName = () => function (input, statuses, otherStatuses) {
    let status = _.find(statuses, { value: input });
    if (status) {
        return status.name;
    }
    if (otherStatuses) {
        status = _.find(otherStatuses, { value: input });
        if (status) {
            return status.name;
        }
    }
    return null;
};

export const getLanguageName = () => function (input, languages) {
    const language = _.find(languages, { id: input.languageCodeId });
    if (language) {
        return language.text;
    }
};

export const getDatesEmployment = () => function (input) {
    if (input.startDate) {
        let start = new Date(input.startDate);
        let end = new Date();

        if (input.endDate) {
            start = new Date(input.startDate);
            end = new Date(input.endDate);
        }

        const yearMonthsCount = (end.getFullYear() - start.getFullYear()) * 12;
        const startMonthCount = start.getMonth() + 1;
        const endMonthCount = end.getMonth() + 1;
        const monthDiffCount = endMonthCount - startMonthCount + 1; // including current month
        input.monthsOfWork = yearMonthsCount + monthDiffCount;
    }
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
    ];

    let startDate = '';
    let endDate = '';
    let noCopy = true;
    if (monthNames[moment(input.startDate)
        .month()] == 'January' &&
        monthNames[moment(input.endDate)
            .month()] == 'January') {
        startDate = moment(input.startDate)
            .year();
        endDate = moment(input.endDate)
            .year();
        if (input.monthsOfWork) {
            endDate = `${endDate} ( `;
            if ((input.monthsOfWork / 12).toString()
                .split('.')[0] !== '0') {
                endDate = `${endDate + (input.monthsOfWork / 12).toString()
                    .split('.')[0]} year`;
            } else if (input.monthsOfWork > 0 && noCopy) {
                noCopy = false;
                endDate = `${endDate} ${input.monthsOfWork} months`;
            } else {
                endDate = `${endDate} ${1} months`;
            }
            if (input.monthsOfWork % 12 > 0 && noCopy) {
                noCopy = false;
                endDate = `${endDate} ${input.monthsOfWork % 12} months`;
            }
            endDate = `${endDate} ) `;
        }
    } else {
        startDate = `${monthNames[moment(input.startDate)
            .month()]} ${moment(input.startDate)
            .year()}`;
        if (input.isCurrent != true && input.endDate) {
            endDate = `${monthNames[moment(input.endDate)
                .month()]} ${moment(input.endDate)
                .year()}`;
            if (input.monthsOfWork) {
                endDate = `${endDate} ( `;
                if ((input.monthsOfWork / 12).toString()
                    .split('.')[0] !== '0') {
                    endDate = `${endDate + (input.monthsOfWork / 12).toString()
                        .split('.')[0]} year`;
                } else if (input.monthsOfWork > 0 && noCopy) {
                    noCopy = false;
                    endDate = `${endDate} ${input.monthsOfWork} months`;
                } else {
                    endDate = `${endDate} ${1} months`;
                }
                if (input.monthsOfWork % 12 > 0 && noCopy) {
                    noCopy = false;
                    endDate = `${endDate} ${input.monthsOfWork % 12} months`;
                }
                endDate = `${endDate} ) `;
            }
        } else {
            if ((input.monthsOfWork / 12).toString()
                .split('.')[0] !== '0') {
                endDate = `${(input.monthsOfWork / 12).toString()
                    .split('.')[0]} year`;
            } else if (input.monthsOfWork > 0 && noCopy) {
                noCopy = false;
                endDate = `${endDate} ${input.monthsOfWork} months`;
            } else {
                endDate = `${endDate} ${1} months`;
            }
            if (input.monthsOfWork % 12 > 0 && noCopy) {
                noCopy = false;
                endDate = `${endDate} ${input.monthsOfWork % 12} months`;
            }
            endDate = `Present ( ${endDate} ) `;
        }
    }
    let location = '';
    if (input.location) {
        if (input.location.city) {
            location = input.location.city;
        }
        if (input.location.region || input.location.state) {
            if (location) {
                location = `${location}, `;
            }
            location = `${location + (input.location.region || '')} ${input.location.state || ''}`;
        }
        if (input.location.country) {
            if (location) {
                location = `${location}, `;
            }
            location += input.location.country;
        }
    }
    return `${startDate} - ${endDate} ${location}`;
};

export const getWebsites = (utils) => (input, isWebSite) => {
    return _.filter(input, (website) => {
        if (isWebSite === true) {
            return utils.isWebsite(website);
        }

        return !utils.isWebsite(website);
    });
};

export const getDate = () => function (input) {
    return moment(input)
        .format('DD/MM/YYYY');
};

export const getIndustryName = () => function (input) {
    if (!input) {
        return;
    }
    let industries = '';
    for (let i = 0; i < input.length; i++) {
        industries += input[i].industryName;
        if (i < input.length - 1) {
            industries = `${industries}, `;
        }
    }
    return industries;
};

export const showCSV = () => function (input) {
    if (input) {
        for (let i = 0; i < input.length; i++) {
            if (input[i].check === true) {
                return true;
            }
        }
    }
    return false;
};

angular
    .module('TALENYA-FE')
    .filter('range', range)
    .filter('getDisplayCandidateTitles', getDisplayCandidateTitles)
    .filter('getJobSeekerName', getJobSeekerName)
    .filter('getLanguageName', getLanguageName)
    .filter('getDatesEmployment', getDatesEmployment)
    .filter('getWebsites', getWebsites)
    .filter('getDate', getDate)
    .filter('getIndustryName', getIndustryName)
    .filter('showCSV', showCSV);
